export default __webpack_public_path__ + "static/media/info-maps.6f67a059.svg";